import Carousel from 'react-bootstrap/Carousel';
import Img01 from '../assets/01.jpg';
import Img02 from '../assets/02.jpg';
import Img05 from '../assets/05.jpg';
import Img07 from '../assets/07.jpg';

export default function ControlledCarousel() {
  return (
    <Carousel fade data-bs-theme="dark" style={{maxWidth: '100'}}>
      <Carousel.Item>
        <img
          className="carouselImage"
          src={Img01}
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="carouselImage"
          src={Img02}
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="carouselImage"
          src={Img05}
          alt="Third slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="carouselImage"
          src={Img07}
          alt="Third slide"
        />
      </Carousel.Item>
    </Carousel>
  );
};
